// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mt-1[data-v-335d2f14] {\r\n  margin-top: 6px;\n}\n.description[data-v-335d2f14] {\r\n  padding: 16px;\r\n  position: relative;\r\n  border-radius: 4px;\r\n  margin-bottom: 20px;\r\n  color: #515a6e;\r\n  line-height: 1.5;\r\n  font-size: 14px;\r\n  border: 1px solid #abdcff;\r\n  background-color: #f0faff;\n}\n.iconfont[data-v-335d2f14] {\r\n  color: #06c05f;\n}\r\n", ""]);
// Exports
module.exports = exports;
